// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"636":"54faeb8f9f6a3e97","1836":"5a05c16fb58946ae","5735":"beb578cc985d134d"}[chunkId] + ".css";
};